import Button from 'components/Form/Button';
import UploadCSV from 'components/Form/UploadCSV';
import Wrapper from 'components/Modal/Wrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { ReadAddressesByZipCode } from 'services/api';
import { getProfissionalClasses } from 'services/api-omni';
import { Update } from 'services/financing-eproposta';
import { Create } from 'services/financing-proposals';
import { ReadOne } from 'services/pre-proposal';
import { getTodos } from 'services/produtos';
import { Title } from 'ui/styled';
import { exposeStrapiError } from 'utils';
import {
  esadoCivilOptions,
  genderOptions,
  nacionalidadeOptions,
  optionsOrgaoEmissorRg,
  optionsStates,
  situacOptions,
} from 'utils/options';
import {
  formatDocuments,
  formatPhone,
  unmaskPhone,
  unparseCurrency,
} from 'utils/parsers';
import { normalizeName } from 'utils/validators';
import FormCore from '../../components/Form/Core';
import {
  ButtonContainer,
  FinancingProposalFormsWrapper,
  FormSpacing,
  HeaderButtonContainer,
} from './styled';
import {
  handleAcceptedBanking,
  handleCarencia,
  handleOcupacaoCodePayload,
  handleProfissaoCodePayload,
} from './utils';

export default function FinancingProposalNew() {
  const history = useHistory();
  const { id } = useParams();
  const { user, reloadContent, setModal } = useContext(CoreContext);
  const refForm = useRef();
  const refFormAddressInstall = useRef();
  const refFormCliente = useRef();
  const refFormProfessional = useRef();
  const refFormDecline = useRef();
  const refFormFinancial = useRef();
  const csvRef = useRef();
  const [loading, setLoading] = useState(false);
  const [isBanking, setIsBanking] = useState(false);
  const [professionalClasses, setProfessionalClasses] = useState([]);
  const [marcasMod, setMarcasMod] = useState([]);
  const [marcasInv, setMarcasInv] = useState([]);
  const [distribuidores, setDistribuidores] = useState([]);
  const [distribuidoresDisplay, setDistribuidoresDisplay] = useState([]);
  const [tipoCliente, setTipoCliente] = useState('fisica');
  const [professionalDescription, setProfessionalDescription] = useState();
  const [registers, setRegisters] = useState(null);
  const [isBankingData, setIsBankingData] = useState({});
  const [declineModal, setDeclineModal] = useState(false);
  const [proposalId, setProposalId] = useState();
  const [isEproposal, setIsEproposal] = useState(false);

  // preenche automaticamente se vier do e proposta
  const selecionarEProposta = useCallback(
    async (registro) => {
      // registro é o objeto direto que vem dentro de results[]
      if (!registro) return;

      const bankAccepted = handleAcceptedBanking(registro);

      const registerIsBanking = !!registro?.isBanking;

      setIsBanking(registerIsBanking);
      if (registerIsBanking) {
        try {
          const res = await getProfissionalClasses({
            distributorId: registro.distribuidor.id,
          });
          setProfessionalClasses(res?.classesProfissionais);
        } catch (err) {
          console.error('Erro Omni:', err);
        }
      }
      // Dados diretos do objeto (não precisa do .result)
      const data = registro;

      setProposalId(data.id);

      if (registerIsBanking) {
        const isBankingPreData = {
          cnpj_empresa: data.informacoes_profissionais.cnpj_empresa,
          nome_empresa: data.informacoes_profissionais.nome_empresa,
          telefone_empresa: data.informacoes_profissionais.telefone_empresa,
          tempo_empresa: data.informacoes_profissionais.tempo_empresa,
          renda_mensal: data.informacoes_profissionais.renda_mensal,
          patrimonio_estimado:
            data.informacoes_profissionais.patrimonio_estimado,
          situacao_imovel: data.situacao_imovel,
          ocupacao_code: data.informacoes_profissionais.ocupacao_code,
          ocupacao: data.informacoes_profissionais.ocupacao,
          profissao_code: data.informacoes_profissionais.profissao_code,
          profissao: data.informacoes_profissionais.profissao,
        };
        setIsBankingData(isBankingPreData);

        if (
          isBankingPreData.profissao_code &&
          isBankingPreData.ocupacao_code &&
          isBankingPreData.ocupacao
        ) {
          setProfessionalDescription(isBankingPreData.ocupacao);
        }
      }

      //setTimeout(() => {
      //    try {
      refFormCliente?.current?.setItem(
        data?.id_pre_proposta.toString(),
        'id_pre_proposta'
      );
      // Pequeno delay para garantir que os formulários estão montados
      setTimeout(() => {
        try {
          // === 1. FORMULÁRIO DO CLIENTE ===
          const cpfCnpj =
            data?.informacoes_cliente?.cpf ||
            data?.informacoes_cliente?.cnpj ||
            '';
          const tipoPessoa =
            data?.informacoes_cliente?.tipo_cliente === 'fisica' ||
            cpfCnpj.replace(/\D/g, '').length === 11
              ? 'fisica'
              : 'juridica';
          refFormCliente?.current?.setItem(tipoPessoa, 'tcc2');
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente?.nome_completo?.trim() || '',
            'nome_completo'
          );
          refFormCliente?.current?.setItem(cpfCnpj, 'cpf');
          refFormCliente?.current?.setItem(
            data.informacoes_cliente.email || '',
            'email'
          );
          refFormCliente?.current?.setItem(
            formatPhone('', data?.informacoes_cliente?.telefone_celular),
            'telefone_celular'
          );
          refFormCliente?.current?.setItem(
            formatPhone(
              undefined,
              !data?.informacoes_cliente?.telefone_fixo
                ? null
                : data.informacoes_cliente.telefone_fixo
            ),
            'telefone_fixo'
          );
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente.data_nascimento || '',
            'data_nascimento'
          );
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente?.estado_civil || '',
            'estado_civil'
          );
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente?.nome_mae || '',
            'nome_mae'
          );
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente?.rg || '',
            'rg'
          );
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente?.genero || '',
            'genero'
          );
          refFormCliente?.current?.setItem(
            data?.informacoes_cliente?.nacionalidade || '',
            'nacionalidade'
          );
          // Endereço residencial do cliente
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.cep || '',
            'cep_cliente'
          );
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.rua || '',
            'logradouro_cliente'
          );
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.numero || '',
            'numero_cliente'
          );
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.complemento || '',
            'complemento'
          );
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.bairro || '',
            'bairro'
          );
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.cidade || '',
            'cidade'
          );
          refFormCliente?.current?.setItem(
            data?.endereco_residencial?.uf || '',
            'estado'
          );

          refFormCliente?.current.setItem(
            data?.informacoes_cliente.rg_emissor || '',
            'rg_emissor'
          );
          refFormCliente?.current.setItem(
            data?.informacoes_cliente.rg_emissor_uf || '',
            'rg_emissor_uf'
          );
          refFormCliente?.current.setItem(
            data?.informacoes_cliente.rg_data_emissao || '',
            'rg_data_emissao'
          );

          // === 2. ENDEREÇO DE INSTALAÇÃO (mesmo do cliente na pré-proposta) ===
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.cep || '',
            'cep'
          );
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.rua || '',
            'rua'
          );
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.numero || '',
            'numero'
          );
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.complemento || '',
            'complemento'
          );
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.bairro || '',
            'bairro'
          );
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.cidade || '',
            'cidade'
          );
          refFormAddressInstall?.current?.setItem(
            data?.endereco_instalacao?.uf || '',
            'estado'
          );
          // === 3. INFORMAÇÕES PROFISSIONAIS ===
          if (data?.informacoes_profissionais && refFormProfessional?.current) {
            refFormProfessional.current.setItem(
              data.informacoes_profissionais.renda_mensal,
              'renda_mensal'
            );
            refFormProfessional.current.setItem(
              data.informacoes_profissionais.nome_empresa,
              'nome_empresa'
            );
            refFormProfessional.current.setItem(
              data.informacoes_profissionais.patrimonio_estimado,
              'patrimonio_estimado'
            );
            refFormProfessional.current.setItem(
              data.informacoes_profissionais.cnpj_empresa,
              'cnpj_empresa'
            );
            refFormProfessional.current.setItem(
              data?.informacoes_profissionais.tempo_empresa,
              'tempo_empresa'
            );
            refFormProfessional.current.setItem(
              data?.informacoes_profissionais.telefone_empresa,
              'telefone_empresa'
            );
            refFormProfessional.current.setItem(
              data?.situacao_imovel,
              'situacao_imovel'
            );

            refFormProfessional.current.setItem(
              data?.informacoes_profissionais.profissao,
              'profissao'
            );
            refFormProfessional.current.setItem(
              data?.informacoes_profissionais.ocupacao,
              'ocupacao'
            );
            refFormProfessional.current.setItem(
              data?.informacoes_profissionais.profissao_code,
              'profissao_code'
            );
            refFormProfessional.current.setItem(
              data?.informacoes_profissionais.ocupacao_code,
              'ocupacao_code'
            );
          }
          // === 4. DADOS DO PROJETO (principais) ===
          if (refForm?.current) {
            // Marca como vindo da pré-proposta
            // refForm.current.setItem(`${data.id}`, 'cod_proposta_externa');
            // Valor total do financiamento = custo do projeto
            //const valor = data?.valor_financiamento || 0;
            refForm.current.setItem(
              data?.informacoes_projeto?.custo_produto || 0,
              'custo_produto'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.custo_servico || 0,
              'custo_servico'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.custo_total_projeto,
              'custo_total_projeto'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.quantidade_placas,
              'quantidade_placas'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.marca_placas,
              'marca_placas'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.quantidade_inversores,
              'quantidade_inversores'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.marca_inversores,
              'marca_inversores'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.geracao_energia_estimada,
              'geracao_energia_estimada'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.unidade_consumidora,
              'unidade_consumidora'
            );

            refForm.current.setItem(
              data?.informacoes_projeto?.concessionaria,
              'concessionaria'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.potencia_W_placas,
              'potencia_modulo'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.potencia_kW_inversor,
              'potencia_kW_inversor'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.potencia_kWp,
              'potencia_kWp'
            );

            refForm.current.setItem(
              data?.cod_proposta_externa,
              'cod_proposta_externa'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.empresa_vendedor_cnpj || '',
              'cnpj_integrador'
            );
            refForm.current.setItem(
              formatPhone('', data?.informacoes_projeto?.telefone_vendedor),
              'telefone_vendedor'
            );
            refForm.current.setItem(
              formatPhone('', data?.telefone_integrador),
              'telefone_integrador'
            );
            refForm.current.setItem(
              data?.informacoes_projeto?.nome_vendedor || '',
              'nome_vendedor'
            );

            refForm.current.setItem(data?.distribuidor?.id, 'distribuidor');
            //monta o array apenas com o distribuidor da pré proposta
            setDistribuidoresDisplay([
              {
                id: data?.distribuidor?.id,
                title: data.distribuidor?.trade_name,
                name: data.distribuidor?.trade_name,
              },
            ]);
          }
          // === DADOS FINANCEIROS ===

          if (refFormFinancial?.current && user?.administrador) {
            refFormFinancial.current.setItem(
              bankAccepted?.banco?.razao_social,
              'banco_aceito'
            );
            refFormFinancial.current.setItem(
              bankAccepted?.valor_parcelas,
              'valor_parcela'
            );
            refFormFinancial.current.setItem(
              bankAccepted?.prazo_financiamento,
              'qtd_parcelas'
            );
            refFormFinancial.current.setItem(
              bankAccepted?.carencia || 0,
              'carencia'
            );
          }
        } catch (err) {
          console.error('Erro ao preencher formulário:', err);
          toast.error('Erro ao carregar dados da pré-proposta.');
        }
      }, 500);
    },
    [user.administrador]
  );

  // preenche automaticamente se vier do pre-proposta
  const selecionarPreProposta = useCallback(
    async (registro) => {
      // registro é o objeto direto que vem dentro de results[]

      if (!registro) return;
      const bankAccepted = handleAcceptedBanking(registro);

      handleCarencia(registro?.data_aprovado, bankAccepted?.data);

      const registerIsBanking = !!registro?.isBanking;

      setIsBanking(registerIsBanking);
      if (registerIsBanking) {
        try {
          const res = await getProfissionalClasses({
            distributorId: registro.distribuidor.id,
          });
          setProfessionalClasses(res?.classesProfissionais);
        } catch (err) {
          console.error('Erro Omni:', err);
        }
      }
      // Dados diretos do objeto (não precisa do .result)
      const data = registro;

      //setTimeout(() => {
      //    try {
      refFormCliente?.current?.setItem(data?.id.toString(), 'id_pre_proposta');
      // Pequeno delay para garantir que os formulários estão montados
      setTimeout(() => {
        try {
          // === 1. FORMULÁRIO DO CLIENTE ===
          const cpfCnpj = data?.cpf || data?.cnpj || '';
          const tipoPessoa =
            data?.tipo_cliente === 'fisica' ||
            cpfCnpj.replace(/\D/g, '').length === 11
              ? 'fisica'
              : 'juridica';
          refFormCliente?.current?.setItem(tipoPessoa, 'tcc2');
          refFormCliente?.current?.setItem(
            data?.nome_completo?.trim() || '',
            'nome_completo'
          );
          refFormCliente?.current?.setItem(cpfCnpj, 'cpf');
          refFormCliente?.current?.setItem(data.email || '', 'email');
          refFormCliente?.current?.setItem(
            formatPhone('', data?.celular),
            'telefone_celular'
          );
          refFormCliente?.current?.setItem('', 'telefone_fixo'); // não vem na pré-proposta
          refFormCliente?.current?.setItem(
            data?.data_nascimento || '',
            'data_nascimento'
          );
          refFormCliente?.current?.setItem('', 'estado_civil'); // pode vir depois
          refFormCliente?.current?.setItem('', 'nome_mae'); // pode vir depois
          refFormCliente?.current?.setItem('', 'rg'); // pode vir depois
          refFormCliente?.current?.setItem('', 'genero'); // pode vir depois
          refFormCliente?.current?.setItem('', 'nacionalidade'); // pode vir depois
          // Endereço residencial do cliente
          refFormCliente?.current?.setItem(data?.cep || '', 'cep_cliente');
          refFormCliente?.current?.setItem(
            data?.logradouro || '',
            'logradouro_cliente'
          );
          refFormCliente?.current?.setItem(
            data?.numero || '',
            'numero_cliente'
          );
          refFormCliente?.current?.setItem(
            data?.complemento || '',
            'complemento'
          );
          refFormCliente?.current?.setItem(data?.bairro || '', 'bairro');
          refFormCliente?.current?.setItem(data?.cidade || '', 'cidade');
          refFormCliente?.current?.setItem(data?.uf || '', 'estado');
          // === 2. ENDEREÇO DE INSTALAÇÃO (mesmo do cliente na pré-proposta) ===
          refFormAddressInstall?.current?.setItem(data?.cep || '', 'cep');
          refFormAddressInstall?.current?.setItem(
            data?.logradouro || '',
            'rua'
          );
          refFormAddressInstall?.current?.setItem(data?.numero || '', 'numero');
          refFormAddressInstall?.current?.setItem(
            data.complemento || '',
            'complemento'
          );
          refFormAddressInstall?.current?.setItem(data?.bairro || '', 'bairro');
          refFormAddressInstall?.current?.setItem(data?.cidade || '', 'cidade');
          refFormAddressInstall?.current?.setItem(data?.uf || '', 'estado');
          // === 3. INFORMAÇÕES PROFISSIONAIS ===
          if (data.renda_mensal && refFormProfessional?.current) {
            refFormProfessional.current.setItem(
              data.renda_mensal,
              'renda_mensal'
            );
          }
          // === 4. DADOS DO PROJETO (principais) ===
          if (refForm?.current) {
            // Marca como vindo da pré-proposta
            // refForm.current.setItem(`${data.id}`, 'cod_proposta_externa');
            // Valor total do financiamento = custo do projeto
            const valor = data?.valor_financiamento || 0;
            refForm.current.setItem(valor, 'custo_produto');
            refForm.current.setItem(valor, 'custo_total_projeto');
            refForm.current.setItem(
              data?.cnpj_integrador || '',
              'cnpj_integrador'
            );
            refForm.current.setItem(
              formatPhone('', data?.telefone_vendedor),
              'telefone_vendedor'
            );
            refForm.current.setItem(data?.nome_vendedor || '', 'nome_vendedor');

            refForm.current.setItem(data?.distribuidor?.id, 'distribuidor');
            //monta o array apenas com o distribuidor da pré proposta
            setDistribuidoresDisplay([
              {
                id: data?.distribuidor?.id,
                title: data.distribuidor?.trade_name,
                name: data.distribuidor?.trade_name,
                cnpj: data.distribuidor?.cnpj,
              },
            ]);
          }

          if (refFormFinancial?.current && user?.administrador) {
            refFormFinancial.current.setItem(
              bankAccepted?.banco?.razao_social,
              'banco_aceito'
            );
            refFormFinancial.current.setItem(
              bankAccepted?.valor_parcelas,
              'valor_parcela'
            );
            refFormFinancial.current.setItem(
              bankAccepted?.prazo_financiamento,
              'qtd_parcelas'
            );
            refFormFinancial.current.setItem(
              bankAccepted?.carencia || 0,
              'carencia'
            );
          }
        } catch (err) {
          console.error('Erro ao preencher formulário:', err);
          toast.error('Erro ao carregar dados da pré-proposta.');
        }
      }, 500);
    },
    [user?.administrador]
  );

  const buscaPre = useCallback(
    async (idPre) => {
      if (!idPre || idPre === 'new') {
        return;
      }

      const resultado = await ReadOne(idPre);

      if (!resultado.e_proposal) {
        setRegisters(resultado);
        await selecionarPreProposta(resultado);
      } else {
        setIsEproposal(true);
        const eProposal = {
          ...resultado.e_proposal,
          id_pre_proposta: idPre,
          distribuidor: resultado.distribuidor,
          bancos: resultado.bancos,
          isBanking: resultado.isBanking,
          data_aprovado: resultado?.data_aprovado,
        };
        setRegisters(eProposal);
        await selecionarEProposta(eProposal);
      }
    },
    [selecionarEProposta, selecionarPreProposta]
  );
  const pessoFisJudi = [
    { id: 'fisica', title: 'Fisica' },
    { id: 'juridica', title: 'Juridica' },
  ];
  const init = useCallback(async () => {
    const result = await getTodos();
    if (result && !exposeStrapiError(result)) {
      const mod = [];
      const inv = [];
      const dist = [];
      for (var i = 0; i < result?.data.length; i++) {
        const item = result.data[i];
        if (item.attributes.ativo) {
          if (item.attributes.tipo === 'Inversor') {
            inv.push({
              id: item.attributes.marca,
              title: item.attributes.marca,
              name: item.attributes.marca,
            });
          } else {
            mod.push({
              id: item.attributes.marca,
              title: item.attributes.marca,
              name: item.attributes.marca,
              setDistribuidores,
            });
          }
        }
      }
      user?.distribuidores?.forEach((element) => {
        dist.push({
          id: element?.id,
          title: element?.trade_name,
          name: element?.trade_name,
          cnpj: element?.cnpj,
        });
      });
      dist.push({
        id: user?.distribuidor?.id,
        title: user?.distribuidor?.trade_name,
        name: user?.distribuidor?.trade_name,
        cnpj: user?.distribuidor?.cnpj,
      });
      setMarcasMod(mod.sort((a, b) => a.title.localeCompare(b.title)));
      setMarcasInv(inv.sort((a, b) => a.title.localeCompare(b.title)));
      setDistribuidores(dist.sort((a, b) => a.title.localeCompare(b.title)));
      if (id !== 'new') {
        await buscaPre(id);
      }
    }
  }, [id, user, buscaPre]);

  useEffect(() => init(), [init]);

  // nao se distribuidores diretamente para nao zoar o formItems quando vier de pre proposta
  useEffect(() => {
    if (distribuidores.length > 0) {
      setDistribuidoresDisplay(distribuidores);
    }
  }, [distribuidores]);

  // Função para calcular potência em kWp
  const handleCalculoPotencia = useCallback(() => {
    setTimeout(() => {
      const qtde = Number(refForm.current?.getItem('quantidade_placas') || 0);
      const watts = Number(refForm.current?.getItem('potencia_modulo') || 0);
      const kwp = (qtde * watts) / 1000;
      refForm.current?.setItem(kwp.toFixed(2), 'potencia_kWp');
    }, 100);
  }, []);

  const classesOptions = useMemo(() => {
    return (
      professionalClasses?.map((item) => ({
        id: item.codigo,
        title: item.descricao,
      })) || []
    );
  }, [professionalClasses]);

  const formItems = [
    // Inserir coluna "Distribuidora" condicionalmente
    ...(user?.distribuidor
      ? [
          {
            ref: 'distribuidor',
            placeholder: 'Distribuidor',
            options: distribuidoresDisplay,
            required: true,
            defaultValue: user?.distribuidor?.id
              ? String(user?.distribuidor?.id)
              : '',
            disabled: !user?.administrador,
          },
        ]
      : []),
    {
      ref: 'cnpj_integrador',
      placeholder: 'CNPJ Integrador',
      mask: '99.999.999/9999-99',
      tress: true,
      required: true,
    },
    {
      ref: 'telefone_integrador',
      placeholder: 'Telefone Integrador',
      mask: '(99)99999-9999',
      disabled: false,
      tress: true,
      required: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'nome_vendedor',
      placeholder: 'Nome Completo do Vendedor',
      tress: true,
      required: true,
    },
    {
      ref: 'telefone_vendedor',
      placeholder: 'Telefone do Vendedor',
      mask: '(99)99999-9999',
      disabled: false,
      tress: true,
      required: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'custo_produto',
      type: 'money',
      placeholder: 'Valor dos Produtos',
      tress: true,
      required: true,
      onBlur: () => {
        let custProd = refForm?.current?.getItem('custo_produto') || 0;
        let custServ = refForm?.current?.getItem('custo_servico') || 0;
        let custOutros =
          refForm?.current?.getItem('valor_outros_produtos') || 0;
        refForm?.current?.setItem(
          custProd + custServ + custOutros,
          'custo_total_projeto'
        );
      },
    },
    {
      ref: 'custo_servico',
      type: 'money',
      placeholder: 'Valor do Serviço',
      tress: true,
      required: false,
      onBlur: () => {
        let custProd = refForm?.current?.getItem('custo_produto') || 0;
        let custServ = refForm?.current?.getItem('custo_servico') || 0;
        let custOutros =
          refForm?.current?.getItem('valor_outros_produtos') || 0;
        refForm?.current?.setItem(
          custProd + custServ + custOutros,
          'custo_total_projeto'
        );
      },
    },
    {
      ref: 'valor_outros_produtos',
      type: 'money',
      placeholder: 'Valor Outros',
      required: false,
      default: 0,
      tress: true,
      onBlur: () => {
        let custProd = refForm?.current?.getItem('custo_produto') || 0;
        let custServ = refForm?.current?.getItem('custo_servico') || 0;
        let custOutros =
          refForm?.current?.getItem('valor_outros_produtos') || 0;
        refForm?.current?.setItem(
          custProd + custServ + custOutros,
          'custo_total_projeto'
        );
      },
    },
    {
      ref: 'custo_total_projeto',
      type: 'money',
      placeholder: 'Valor Total',
      tress: true,
      required: false,
      disabled: true,
    },
    {
      ref: 'quantidade_placas',
      type: 'number',
      placeholder: 'Quantidade de Módulos',
      tress: true,
      required: true,
      min: '0',
      step: '1',
      onChange: handleCalculoPotencia,
    },
    {
      ref: 'marca_placas',
      placeholder: 'Marca dos Módulos',
      options: marcasMod,
      tress: true,
      required: true,
    },
    {
      ref: 'potencia_modulo',
      type: 'number',
      placeholder: 'Potência W dos Módulos',
      tress: true,
      required: true,
      min: '0',
      step: '0.01',
      onBlur: handleCalculoPotencia,
    },
    {
      ref: 'potencia_kWp',
      type: 'number',
      placeholder: 'Potência kWp Total',
      tress: true,
      required: false,
      disabled: true,
    },
    {
      ref: 'quantidade_inversores',
      type: 'number',
      placeholder: 'Quantidade de Inversores',
      tress: true,
      required: true,
    },
    {
      ref: 'marca_inversores',
      placeholder: 'Marca dos Inversores',
      options: marcasInv,
      tress: true,
      required: true,
    },
    {
      ref: 'potencia_kW_inversor',
      type: 'number',
      placeholder: 'Potência kW Total',
      tress: true,
      required: true,
    },
    {
      ref: 'geracao_energia_estimada',
      type: 'number',
      placeholder: 'Geração de Energia kW/h no Primeiro Ano',
      required: true,
      tress: true,
    },
    {
      ref: 'concessionaria',
      placeholder: 'Concessionária de Energia',
      required: true,
      tress: true,
    },
    {
      ref: 'unidade_consumidora',
      placeholder: 'Unidade Consumidora',
      required: true,
      tress: true,
    },
    {
      ref: 'cod_proposta_externa',
      placeholder: 'Número da Proposta Comercial',
      required: false,
      tress: true,
    },
  ];

  const formItemsAddress = [
    {
      ref: 'cep',
      placeholder: 'CEP',
      mask: '99999-999',
      tress: true,
      required: true,
      onBlur: async (event) => {
        const cep = event.target.value.replace(/\D/g, '');
        if (cep.length === 8) {
          try {
            const data = await ReadAddressesByZipCode(cep);
            if (data) {
              refFormAddressInstall?.current?.setItem(data.logradouro, 'rua');
              refFormAddressInstall?.current?.setItem(data.bairro, 'bairro');
              refFormAddressInstall?.current?.setItem(
                data.localidade,
                'cidade'
              );
              refFormAddressInstall?.current?.setItem(data.uf, 'estado');
              refFormAddressInstall?.current?.setItem('', 'numero');
              refFormAddressInstall?.current?.setItem('', 'complemento');
            }
          } catch (err) {
            console.warn('Erro ao buscar CEP:', err);
            toast.warn('CEP não encontrado.');
          }
        }
      },
    },
    { ref: 'rua', placeholder: 'Logradouro', tress: true, required: true },
    {
      ref: 'numero',
      placeholder: 'Número',
      tress: true,
      required: true,
      type: 'number',
    },
    {
      ref: 'complemento',
      placeholder: 'Complemento',
      tress: true,
      required: false,
    },
    { ref: 'bairro', placeholder: 'Bairro', tress: true, required: true },
    { ref: 'cidade', placeholder: 'Cidade', tress: true, required: true },
    { ref: 'estado', placeholder: 'Estado', tress: true, required: true },
  ];

  const formCliente = [
    {
      ref: 'tcc2',
      placeholder: 'Tipo de Pessoa',
      options: pessoFisJudi,
      required: true,
      tress: true,
      onBlur: async () => {
        const value = refFormCliente?.current?.getItem('tcc2');
        setTipoCliente(value);
      },
    },
    {
      ref: 'nome_completo',
      placeholder: 'Nome Completo',
      required: true,
      tress: true,
    },
    {
      ref: 'cpf',
      placeholder: 'CPF/CNPJ',
      type: 'cpf',
      required: true,
      tress: true,
    },
    {
      ref: 'data_nascimento',
      type: 'date',
      placeholder:
        tipoCliente === 'juridica' ? 'Data abertura' : 'Data de Nascimento',
      required: true,
      tress: true,
    },
    { ref: 'email', placeholder: 'E-mail', required: true, tress: true },
    {
      ref: 'telefone_celular',
      placeholder: 'Telefone Celular',
      mask: '(99)99999-9999',
      required: true,
      tress: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'telefone_fixo',
      placeholder: 'Telefone Fixo',
      mask: '(99)9999-9999',
      required: false,
      tress: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'estado_civil',
      placeholder: 'Estado Civil',
      tress: true,
      required: true,
      options: esadoCivilOptions,
    },
    {
      ref: 'nome_mae',
      placeholder: 'Nome Completo da Mãe',
      required: true,
      tress: true,
    },

    ...(isBanking
      ? [
          {
            ref: 'rg',
            placeholder: 'RG',
            type: 'number',
            required: true,
            mask: '99.999.999-99',
            tress: true,
          },
          {
            ref: 'rg_data_emissao',
            placeholder: 'Data de Emissão',
            type: 'date',
            required: true,
            tress: true,
          },
          {
            ref: 'rg_emissor',
            placeholder: 'Orgão Emissor',
            required: true,
            tress: true,
            options: optionsOrgaoEmissorRg,
          },
          {
            ref: 'rg_emissor_uf',
            placeholder: 'UF de Emissão',
            required: true,
            tress: true,
            options: optionsStates,
          },
        ]
      : [
          {
            ref: 'rg',
            placeholder: 'RG',
            type: 'number',
            required: false,
            mask: '99.999.999-99',
            tress: true,
          },
        ]),
    {
      ref: 'genero',
      placeholder: 'Sexo',
      options: genderOptions,
      tress: true,
      required: true,
    },
    {
      ref: 'nacionalidade',
      placeholder: 'Nacionalidade',
      tress: true,
      required: true,
      options: nacionalidadeOptions,
    },
    {
      ref: 'cep_cliente',
      placeholder: 'CEP',
      mask: '99999-999',
      required: true,
      tress: true,
      onBlur: async () => {
        const cep = refFormCliente?.current
          ?.getItem('cep_cliente')
          .replace(/\D/g, '');
        if (cep.length === 8) {
          try {
            const data = await ReadAddressesByZipCode(cep);
            if (data) {
              refFormCliente?.current?.setItem(
                data.logradouro,
                'logradouro_cliente'
              );
              refFormCliente?.current?.setItem(data.bairro, 'bairro');
              refFormCliente?.current?.setItem(data.localidade, 'cidade');
              refFormCliente?.current?.setItem(data.uf, 'estado');
              refFormAddressInstall?.current?.setItem(data.cep, 'cep');
              refFormAddressInstall?.current?.setItem(data.logradouro, 'rua');
              refFormAddressInstall?.current?.setItem(data.bairro, 'bairro');
              refFormAddressInstall?.current?.setItem(
                data.localidade,
                'cidade'
              );
              refFormAddressInstall?.current?.setItem(data.uf, 'estado');
              refFormAddressInstall?.current?.setItem(
                refFormCliente?.current?.getItem('numero_cliente'),
                'numero'
              );
            }
          } catch (err) {
            console.warn('Erro ao buscar CEP:', err);
            toast.warn('CEP não encontrado.');
          }
        }
      },
    },
    {
      ref: 'logradouro_cliente',
      placeholder: 'Logradouro',
      tress: true,
      required: true,
      onBlur: () =>
        refFormAddressInstall?.current?.setItem(
          refFormCliente?.current?.getItem('logradouro_cliente'),
          'rua'
        ),
    },
    {
      ref: 'numero_cliente',
      placeholder: 'Número',
      tress: true,
      required: true,
      type: 'number',
      onBlur: () =>
        refFormAddressInstall?.current?.setItem(
          refFormCliente?.current?.getItem('numero_cliente'),
          'numero'
        ),
    },
    {
      ref: 'complemento',
      placeholder: 'Complemento',
      tress: true,
      required: false,
      onBlur: () =>
        refFormAddressInstall?.current?.setItem(
          refFormCliente?.current?.getItem('complemento'),
          'complemento'
        ),
    },
    {
      ref: 'bairro',
      placeholder: 'Bairro',
      tress: true,
      required: true,
      onBlur: () =>
        refFormAddressInstall?.current?.setItem(
          refFormCliente?.current?.getItem('bairro'),
          'bairro'
        ),
    },
    {
      ref: 'cidade',
      placeholder: 'Cidade',
      tress: true,
      required: true,
      onBlur: () =>
        refFormAddressInstall?.current?.setItem(
          refFormCliente?.current?.getItem('cidade'),
          'cidade'
        ),
    },
    {
      ref: 'estado',
      placeholder: 'Estado',
      tress: true,
      required: true,
      onBlur: () =>
        refFormAddressInstall?.current?.setItem(
          refFormCliente?.current?.getItem('estado'),
          'estado'
        ),
    },
    {
      ref: 'id_pre_proposta',
      placeholder: 'ID Pré-Proposta',
      required: false,
      disabled: true,
    },
  ];

  const formProfessional = [
    { ref: 'profissao', placeholder: 'Profissão', required: true, tress: true },
    { ref: 'ocupacao', placeholder: 'Ocupação', required: true, tress: true },
    {
      ref: 'nome_empresa',
      placeholder: 'Nome da Empresa',
      required: true,
      tress: true,
    },
    {
      ref: 'telefone_empresa',
      placeholder: 'Telefone da empresa',
      mask: '(99)99999-9999',
      required: true,
      tress: true,
    },
    {
      ref: 'tempo_empresa',
      placeholder: 'Tempo de Empresa (Meses)',
      type: 'number',
      required: true,
      min: 0,
      tress: true,
    },
    {
      ref: 'renda_mensal',
      placeholder: 'Renda Mensal',
      type: 'money',
      required: true,
      tress: true,
    },
    {
      ref: 'patrimonio_estimado',
      placeholder: 'Patrimônio Estimado',
      type: 'money',
      required: true,
      tress: true,
    },
    {
      ref: 'situacao_imovel',
      placeholder: 'Situação do Imóvel',
      required: true,
      options: situacOptions,
      tress: true,
    },
  ];

  const formFinancial = user?.administrador
    ? [
        {
          ref: 'banco_aceito',
          placeholder: 'Banco Aceito',
          tress: true,
          disabled: true,
        },
        {
          ref: 'qtd_parcelas',
          placeholder: 'Quantidade de Parcelas',
          tress: true,
          disabled: true,
        },
        {
          ref: 'valor_parcela',
          placeholder: 'Valor da Parcela',
          tress: true,
          type: 'money',
          disabled: true,
        },
        {
          ref: 'carencia',
          placeholder: 'Carência (dias)',
          tress: true,
          disabled: true,
        },
      ]
    : [];

  const getLabelFromOptions = (id, options) => {
    const selected = options.find((opt) => String(opt.id) === String(id));
    return selected ? selected.title : id;
  };

  const save = async () => {
    if (loading) {
      return;
    }

    setLoading(true);

    const form = refForm?.current?.getForm();
    const formAddressInstall = refFormAddressInstall?.current?.getForm();
    const formCliente = refFormCliente?.current?.getForm();
    const formProfessional = isBanking
      ? isBankingData
      : refFormProfessional?.current?.getForm();
    let isProfessionalValid = false;

    if (isBanking) {
      isProfessionalValid = !!(
        formProfessional?.profissao &&
        formProfessional?.ocupacao &&
        formProfessional?.renda_mensal &&
        formProfessional?.nome_empresa
      );
    } else {
      isProfessionalValid = !!formProfessional;
    }

    if (!form || !formAddressInstall || !formCliente || !isProfessionalValid) {
      setLoading(false);
      toast.error('Todos os campos devem ser preenchidos');
      return;
    }
    const telefoneIntegrador = unmaskPhone(form?.telefone_integrador);
    const telefoneVendedor = unmaskPhone(form?.telefone_vendedor);
    const telefoneCliente = unmaskPhone(formCliente?.telefone_celular);
    if (
      telefoneCliente &&
      (telefoneCliente === telefoneIntegrador ||
        telefoneCliente === telefoneVendedor)
    ) {
      toast.error(
        'O Telefone Celular do Cliente não pode ser o mesmo do Integrador ou do Vendedor.'
      );
      setLoading(false);
      return;
    }

    //verifica se o nome da mae do cliente esta completo (pelo menos 2 palavras)
    if (formCliente?.nome_mae.trim().split(' ').length < 2) {
      toast.error('O nome da mãe do cliente deve ter nome e sobrenome.');
      setLoading(false);
      return;
    }

    const viaCEP = await ReadAddressesByZipCode(formAddressInstall.cep).then(
      (data) => {
        return data;
      }
    );
    let distribuidor;
    if (user.administrador) {
      distribuidor = refForm?.current?.getItem('distribuidor');
    } else {
      distribuidor = user?.distribuidor?.id;
    }
    const payload = {
      situacao_imovel: formProfessional?.situacao_imovel,
      pre_proposal:
        formCliente?.id_pre_proposta?.length > 0
          ? parseInt(formCliente?.id_pre_proposta)
          : null,
      telefone_integrador: unmaskPhone(form?.telefone_integrador),
      cod_proposta_externa: normalizeName(form?.cod_proposta_externa),
      informacoes_projeto: {
        custo_produto: form?.custo_produto + (form?.valor_outros_produtos || 0),
        custo_servico: form?.custo_servico || 0,
        custo_total_projeto: form?.custo_total_projeto,
        quantidade_placas: form?.quantidade_placas,
        marca_placas: form?.marca_placas,
        potencia_W_placas: form?.potencia_modulo,
        quantidade_inversores: form?.quantidade_inversores,
        potencia_kW_inversor: form?.potencia_kW_inversor,
        // potencia_kWp: form?.potencia_kWp,
        marca_inversores: form?.marca_inversores,
        geracao_energia_estimada: parseInt(form?.geracao_energia_estimada),
        cep_instalacao: formAddressInstall?.cep,
        concessionaria: form?.concessionaria,
        unidade_consumidora: form?.unidade_consumidora,
        nome_vendedor: form?.nome_vendedor.trim(),
        telefone_vendedor: unmaskPhone(form?.telefone_vendedor),
        telefone_integrador: unmaskPhone(form?.telefone_integrador),
        integrador: {
          cnpj: form?.cnpj_integrador,
          contato_whatsapp: form?.contato_whatsapp,
          nome_fantasia: form?.nome_fantasia,
        },
      },
      distribuidor: { id: distribuidor },
      endereco_instalacao: {
        rua: formAddressInstall?.rua,
        numero: formAddressInstall?.numero,
        cidade: viaCEP?.localidade || formAddressInstall?.cidade,
        uf: viaCEP?.uf || formAddressInstall?.estado,
        bairro: viaCEP?.bairro || formAddressInstall?.bairro,
        complemento: formAddressInstall?.complemento,
        cep: formAddressInstall?.cep,
      },
      endereco_correspondencia: {
        rua: formAddressInstall?.rua,
        numero: formAddressInstall?.numero,
        cidade: viaCEP?.localidade || formAddressInstall?.cidade,
        uf: viaCEP?.uf || formAddressInstall?.estado,
        bairro: viaCEP?.bairro || formAddressInstall?.bairro,
        complemento: formAddressInstall?.complemento,
        cep: formAddressInstall?.cep,
      },
      endereco_residencial: {
        rua: formAddressInstall?.rua,
        numero: formAddressInstall?.numero,
        cidade: viaCEP?.localidade || formAddressInstall?.cidade,
        uf: viaCEP?.uf || formAddressInstall?.estado,
        bairro: viaCEP?.bairro || formAddressInstall?.bairro,
        complemento: formAddressInstall?.complemento,
        cep: formAddressInstall?.cep,
      },
      informacoes_profissionais: {
        profissao: isBanking
          ? getLabelFromOptions(formProfessional?.profissao, classesOptions)
          : formProfessional?.profissao?.trim(),
        profissao_code: handleProfissaoCodePayload(
          isBanking,
          isEproposal,
          formProfessional
        ),
        ocupacao: isBanking
          ? professionalDescription
          : formProfessional?.ocupacao?.trim(),
        ocupacao_code: handleOcupacaoCodePayload(
          isBanking,
          isEproposal,
          formProfessional
        ),
        tempo_empresa: formProfessional?.tempo_empresa,
        cnpj_empresa: isBanking ? formProfessional.cnpj_empresa : '',
        nome_empresa: formProfessional?.nome_empresa,
        telefone_empresa: unmaskPhone(formProfessional?.telefone_empresa),
        renda_mensal: formProfessional?.renda_mensal,
        patrimonio_estimado: formProfessional?.patrimonio_estimado,
      },
      informacoes_cliente: {
        tipo_cliente: formCliente?.tcc2,
        [formCliente?.tcc2 === 'fisica' ? 'cpf' : 'cnpj']: formCliente?.cpf,
        data_nascimento: formCliente?.data_nascimento,
        email: formCliente?.email,
        telefone_celular: unmaskPhone(formCliente?.telefone_celular),
        telefone_fixo: unmaskPhone(formCliente?.telefone_fixo),
        nome_completo: formCliente?.nome_completo.trim(),
        estado_civil: formCliente?.estado_civil,
        nome_mae: formCliente?.nome_mae.trim(),
        rg: formCliente?.rg?.replace(/\D/g, ''),
        rg_data_emissao:
          formCliente?.rg_data_emissao?.length <= 1
            ? null
            : formCliente?.rg_data_emissao,
        rg_emissor: formCliente?.rg_emissor,
        rg_emissor_uf: formCliente?.rg_emissor_uf,
        genero: formCliente?.genero,
        nacionalidade: formCliente?.nacionalidade,
      },
    };

    const result = await Create({ data: payload }, id);
    if (result && !exposeStrapiError(result)) {
      toast.success('Proposta enviada com sucesso!');
      reloadContent(true);
      history.goBack();
    } else {
      toast.error(
        'Ocorreu um erro ao enviar a proposta. Verifique os dados e tente novamente.'
      );
    }
    setLoading(false);
  };

  // Função para converter valores numéricos
  const converterParaNumero = (valor) => {
    if (typeof valor === 'string') {
      valor = valor.replace(',', '.');
    }
    const numero = parseFloat(valor);
    return isNaN(numero) ? null : numero;
  };
  // Função para parsear o registro do CSV
  const parseRegister = (item) => {
    const codigoCli = formatDocuments(item?.codigo_cliente);
    const payload = {
      situacao_imovel: item?.situacao_imovel,
      informacoes_projeto: {
        custo_produto:
          (unparseCurrency(item?.valor_produtos) || 0) +
          (unparseCurrency(item?.valor_outros_produtos) || 0),
        custo_servico: unparseCurrency(item?.['valor_mao de obra']),
        custo_total_projeto: unparseCurrency(item?.valor_total),
        quantidade_placas: converterParaNumero(
          item?.['qtd_modulo'] || item?.['qtd_módulo']
        ),
        marca_placas: item?.['marca_modulo'] || item?.['marca_módulo'],
        potencia_W_placas: converterParaNumero(
          item?.['potenciaW_modulo'] || item?.['potenciaW_módulo']
        ),
        quantidade_inversores: converterParaNumero(item?.qtd_inversores),
        potencia_kW_inversor: converterParaNumero(item?.['potencia_kW']),
        potencia_kWp: converterParaNumero(item?.['potencia_kWp']),
        marca_inversores: item?.marca_inversores,
        geracao_energia_estimada: parseInt(
          item?.['geracaokWh_1o ano']?.replace(/\./, '')
        ),
        cep_instalacao: item?.cep_instalacao,
        distribuidora_energia: item?.['concessionaria'],
        unidade_consumidora: item?.unidade_consumidora,
        nome_vendedor: item?.nome_vendedor,
        telefone_vendedor: formatPhone('', item?.telefone_vendedor),
        concessionaria: item?.['concessionaria'],
        integrador: {
          cnpj: formatDocuments(item?.cnpj_integrador),
          contato_whatsapp: formatPhone('', item?.['telefone_integrador']),
        },
      },
      informacoes_cliente: {
        tipo_cliente: codigoCli.length === 14 ? 'fisica' : 'juridica',
        [codigoCli.length === 14 ? 'cpf' : 'cnpj']: codigoCli,
        email: item?.email_cliente,
        telefone_celular: formatPhone('', item?.telefone_cliente),
        nome_completo: item?.nome_cliente,
        data_nascimento: item?.data_nascimento,
        telefone_fixo: item?.telefone_fixo,
        estado_civil: item?.estado_civil,
        nome_mae: item?.nome_mae,
        genero: item?.genero,
        nacionalidade: item?.nacionalidade,
        rg: item?.rg,
        endereco_residencial: {
          rua: item?.logradouro_cliente,
          numero: item?.numero_casa_cliente,
          cidade: item?.cidade_cliente,
          uf: item?.uf_cliente,
          estado: item?.estado,
          bairro: item?.bairro_cliente,
          complemento: item?.complemento,
          cep: item?.cep_instalacao,
        },
        endereco_instalacao: {
          rua: item?.logradouro_cliente,
          numero: item?.numero_casa_cliente,
          cidade: item?.cidade_cliente,
          uf: item?.uf_cliente,
          estado: item?.estado,
          bairro: item?.bairro_cliente,
          complemento: item?.complemento,
          cep: item?.cep_instalacao,
        },
        endereco_correspondencia: {
          rua: item?.logradouro_cliente,
          numero: item?.numero_casa_cliente,
          cidade: item?.cidade_cliente,
          estado: item?.estado,
          uf: item?.uf_cliente,
          bairro: item?.bairro_cliente,
          complemento: item?.complemento,
          cep: item?.cep_instalacao,
        },
      },
      informacoes_profissionais: {
        profissao: item?.profissao,
        ocupacao: item?.ocupacao,
        tempo_empresa: item?.tempo_empresa,
        nome_empresa: item?.nome_empresa,
        telefone_empresa: item?.telefone_empresa,
        renda_mensal: unparseCurrency(item?.renda_mensal) || 0,
        patrimonio_estimado: unparseCurrency(item?.patrimonio_estimado) || 0,
      },
      endereco_residencial: {
        rua: item?.logradouro_cliente,
        numero: item?.numero_casa_cliente,
        cidade: item?.cidade_cliente,
        estado: item?.estado,
        uf: item?.uf_cliente,
        bairro: item?.bairro_cliente,
        complemento: item?.complemento,
        cep: item?.cep_instalacao,
      },
      endereco_instalacao: {
        rua: item?.logradouro_cliente,
        numero: item?.numero_casa_cliente,
        cidade: item?.cidade_cliente,
        estado: item?.estado,
        uf: item?.uf_cliente,
        bairro: item?.bairro_cliente,
        cep: item?.cep_instalacao,
        complemento: item?.complemento,
      },
      endereco_correspondencia: {
        rua: item?.logradouro_cliente,
        numero: item?.numero_casa_cliente,
        cidade: item?.cidade_cliente,
        estado: item?.estado,
        uf: item?.uf_cliente,
        bairro: item?.bairro_cliente,
        complemento: item?.complemento,
        cep: item?.cep_instalacao,
      },
      telefone_integrador: formatPhone('', item?.['telefone_integrador']),
      cod_proposta_externa: normalizeName(item?.['num_proposta']) || '',
      distribuidor: user?.distribuidor?.id,
    };
    return payload;
  };
  // Função para salvar um único registro
  const saveCSV = async (item) => {
    const payload = parseRegister(item);
    return await Create({ data: payload });
  };
  // Função para processar o CSV
  const handleCSV = async (result) => {
    let valido = true;
    let linha = 2;
    for (const item of result) {
      let cepConsulta = item.cep_instalacao
        .replaceAll('.', '')
        .replace('-', '');
      let url = `https://viacep.com.br/ws/${cepConsulta}/json/`;
      try {
        const response = await fetch(url, {
          method: 'GET',
          redirect: 'follow',
        });
        const data = await response.json();
        if (data.erro) {
          toast.error(`CEP inexistente ou inválido. Linha: ${linha}`);
          valido = false;
          return;
        }
        item.bairro_cliente = data.bairro;
        item.complemento = data.complemento;
        item.estado = data.estado;
        item.cidade_cliente = data.localidade;
        item.uf_cliente = data.uf;
      } catch (error) {
        toast.error(`Erro ao consultar CEP. Linha: ${linha}`);
        valido = false;
        return;
      }
      // Validação de telefones iguais
      const telefoneIntegrador = unmaskPhone(item?.telefone_integrador);
      const telefoneVendedor = unmaskPhone(item?.telefone_vendedor);
      const telefoneCliente = unmaskPhone(item?.telefone_cliente);
      if (
        telefoneCliente &&
        (telefoneCliente === telefoneIntegrador ||
          telefoneCliente === telefoneVendedor)
      ) {
        toast.error(
          `O Telefone Celular do Cliente não pode ser o mesmo do Integrador ou do Vendedor. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item?.cnpj_integrador) {
        toast.error(
          `Existem registros sem o campo cnpj_integrador preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (item?.cnpj_integrador.length < 14) {
        toast.error(`O CNPJ do integrador não é válido! Linha: ${linha}`);
        valido = false;
        return;
      }
      if (!item?.['qtd_modulo']) {
        toast.error(
          `Existem registros sem o campo qtd_módulo preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item.valor_produtos) {
        toast.error(
          `Existem registros sem o campo valor_produtos preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item?.['valor_mao de obra']) {
        toast.error(
          `Existem registros sem o campo valor_mao de obra preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item.valor_total) {
        toast.error(
          `Existem registros sem o campo valor_total preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item?.['potencia_kW']) {
        toast.error(
          `Existem registros sem o campo potencia_kW preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item?.['potencia_kWp']) {
        toast.error(
          `Existem registros sem o campo potencia_kWp preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item?.['concessionaria']) {
        toast.error(
          `Existem registros sem o campo concessionária preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item.codigo_cliente) {
        toast.error(
          `Existem registros sem o campo codigo_cliente preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item.telefone_cliente) {
        toast.error(`Existem registros sem o campoHorachido. Linha: ${linha}`);
        valido = false;
        return;
      }
      if (!item.cidade_cliente) {
        toast.error(
          `Existem registros sem o campo cidade_cliente preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (!item.uf_cliente) {
        toast.error(
          `Existem registros sem o campo uf_cliente preenchido. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (item.genero !== 'masculino' && item.genero !== 'feminino') {
        toast.error(
          `O campo gênero deve ser masculino ou feminino. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (
        ['casado', 'solteiro', 'viuvo', 'separado'].indexOf(
          item.estado_civil
        ) === -1
      ) {
        toast.error(
          `O campo estado civil deve ser casado, solteiro, separado ou viúvo. Linha: ${linha}`
        );
        valido = false;
        return;
      }
      if (
        formatDocuments(item.codigo_cliente).length !== 14 &&
        formatDocuments(item.codigo_cliente).length !== 18
      ) {
        toast.error(`O CPF/CNPJ do cliente não é válido! Linha: ${linha}`);
        valido = false;
        return;
      }
      linha++;
    }
    if (valido) {
      await saveAll(result);
    }
  };
  // Função para salvar todos os registros do CSV
  const saveAll = async (result) => {
    setLoading(true);
    const promises = result?.map(saveCSV);
    const responses = await Promise.all(promises);
    let qtdCertos = 0;
    if (responses?.filter((f) => f)?.length === responses?.length) {
      for (let response of responses) {
        if (!response.error) {
          qtdCertos++;
        }
      }
      toast.success(`${qtdCertos} propostas importadas com sucesso!`);
      reloadContent(true);
      history.goBack();
    } else {
      toast.error(
        'Ocorreu um erro ao importar algumas propostas. Verifique os dados e tente novamente.'
      );
    }
    setLoading(false);
  };

  return (
    <ContainerAuthenticated>
      <Title>Proposta</Title>
      <FinancingProposalFormsWrapper>
        <HeaderButtonContainer>
          <Title small nomargin>
            {user?.administrador
              ? 'Informações Financeiras'
              : 'Informações do Cliente'}
          </Title>
          <Button
            color="blue"
            width={'fit-content'}
            small
            nospace
            disabled={loading}
            loading={loading}
            onClick={() => history.goBack()}
          >
            Voltar
          </Button>
          {/* <Button
            color="blue"
            width={'fit-content'}
            small
            nospace
            loading={loading}
            onClick={() => csvRef?.current?.upload()}
          >
            Importar CSV
          </Button> */}
        </HeaderButtonContainer>
        {user?.administrador && (
          <>
            <FormCore ref={refFormFinancial} formItems={formFinancial} />
            <Title small nomargin>
              Informações do Cliente
            </Title>
          </>
        )}
        <FormCore ref={refFormCliente} formItems={formCliente} />
        <FormSpacing />
        <Title small nomargin>
          Endereço de Instalação
        </Title>
        <FormCore ref={refFormAddressInstall} formItems={formItemsAddress} />
        <FormSpacing />
        <Title small nomargin>
          Informações do Projeto
        </Title>
        <FormCore ref={refForm} formItems={formItems} />
        <FormSpacing />
        <Title small nomargin>
          Informações Profissionais
        </Title>
        {isBanking ? (
          <ButtonContainer style={{ marginTop: '10px' }}>
            <Button
              color={professionalDescription ? 'green' : 'blue'}
              width={'fit-content'}
              small
              nospace
              onClick={() =>
                setModal({
                  type: 'profissao_omni',
                  dados: isBankingData,
                  classesOptions: classesOptions,
                  distributorId: registers?.distribuidor?.id,
                  onConfirm: (dadosCompletos) => {
                    setIsBankingData(dadosCompletos);

                    refFormProfessional.current?.setValues(dadosCompletos);
                    setProfessionalDescription(dadosCompletos.ocupacao_label);
                  },
                })
              }
            >
              {professionalDescription
                ? `✅ Profissão: ${professionalDescription}`
                : '⚠️ Clique aqui para preencher Info. Profissionais'}
            </Button>
          </ButtonContainer>
        ) : (
          <FormCore ref={refFormProfessional} formItems={formProfessional} />
        )}
        {declineModal && (
          <Wrapper
            onClose={() => setDeclineModal(false)}
            title={'Tem certeza que deseja declinar essa proposta?'}
          >
            <div
              style={{
                paddingTop: '2rem',
                paddingBottom: '2rem',
              }}
            >
              <FormCore
                ref={refFormDecline}
                formItems={[
                  {
                    ref: 'description',
                    placeholder: 'Informe o motivo do declinio:',
                    tress: true,
                    required: false,
                    full: true,
                  },
                ]}
              />
            </div>
            <Button
              width={'fit-content'}
              color={'error'}
              onClick={async () => {
                const declineDescription =
                  refFormDecline?.current?.getItem('description') ?? '';
                const payload = {
                  status: 'recusado',
                  motivo_declinado: declineDescription,
                };
                try {
                  setLoading(true);
                  const result = await Update({ data: payload }, proposalId);
                  if (result.status !== 'ok') {
                    toast.error('Erro ao salvar');
                    throw new Error();
                  } else {
                    toast.success('Recusado com sucesso!');
                    setTimeout(() => {
                      history.goBack();
                    }, 1000);
                  }
                } catch (err) {
                  console.error(err);
                } finally {
                  setLoading(false);
                }
              }}
              small
              loading={loading}
              disabled={loading}
            >
              Declinar
            </Button>
          </Wrapper>
        )}
        <FormSpacing />
        <ButtonContainer>
          <Button
            width={'fit-content'}
            color={'error'}
            onClick={() => {
              setDeclineModal(true);
            }}
            small
            loading={loading}
            disabled={loading}
          >
            Declinar Proposta
          </Button>
          <Button
            color="blue"
            width={'fit-content'}
            small
            nospace
            loading={loading}
            disabled={loading}
            onClick={save}
          >
            Enviar Proposta
          </Button>
        </ButtonContainer>
      </FinancingProposalFormsWrapper>
      <UploadCSV ref={csvRef} onChange={handleCSV} />
    </ContainerAuthenticated>
  );
}
